export const checkRegex = (exp, string) => {
  const reg = new RegExp(exp);

  return reg.test(string);
};
